import { render, staticRenderFns } from "./PartCkuPrvsPopupDTable.vue?vue&type=template&id=1e543a35&"
import script from "./PartCkuPrvsPopupDTable.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsPopupDTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports